/* eslint no-param-reassign: "off", no-console: "off" */
const zonesStore = {
  state: {
    zones: [],
    zonesLoading: false,
    zone: null,
    zoneLoading: false
  },
  mutations: {
    fetchZones(state, payload) {
      state.zones = payload;
    },
    fetchZone(state, payload) {
      state.zone = payload;
    },
    clearZone(state) {
      state.zone = null;
    },
    addZone(state, payload) {
      state.zones.push(payload);
      state.zone = payload;
    },
    updateZone(state, payload) {
      state.zone = payload;
    },
    deleteZone(state, payload) {
      // payload is the zoneId
      state.zones = state.zones.filter(z => z.id != payload);
      state.zone = null;
    }
  },
  actions: {
    /**
     * Fetches a list of zones
     * @param {*} param0 
     * @param {Object} payload - Object containing paging, sorting, filters
     */
    async fetchZones({ state, commit }) {
      state.zonesLoading = true;
      try {
        const res = await fetch('/v2/zones');
        if (!res.ok) throw new Error(await res.text());
        const data = await res.json();
        commit('fetchZones', data);
        state.zonesLoading = false;
        return true;
      } catch (ex) {
        console.error(ex);
        return false;
      }
    },
    /**
     * Fetches an individual zone
     * @param {*} param0 
     * @param {string} payload - Individual remote Id
     */
    async fetchZone({ state, commit }, payload) {
      state.zoneLoading = true;
      try {
        const res = await fetch(`/v2/zones/${payload}`);
        if (!res.ok) throw new Error(await res.text());
        const data = await res.json();
        commit('fetchZone', data);
        state.zoneLoading = false;
        return true;
      } catch (ex) {
        console.error(ex);
        return false;
      }
    },
    async addZone({ commit }, payload) {
      return fetch('/v2/zones', { 
        credentials: 'same-origin', 
        body: JSON.stringify(payload), 
        method: 'POST',
        headers: new Headers({ 'Content-Type': 'application/json' })
      })
        .then(res => res.json())
        .then(data => {
          commit('addZone', data);
          return true;
        })
        // eslint-disable-next-line no-unused-vars
        .catch(err => false);      
    },
    async updateZone({ commit }, payload) {
      return fetch(`/v2/zones/${payload.id}`, { 
        credentials: 'same-origin', 
        body: JSON.stringify(payload), 
        method: 'PUT',
        headers: new Headers({ 'Content-Type': 'application/json' })
      })
        .then(res => res.json())
        .then(data => {
          commit('updateZone', data);
          return true;
        })
        // eslint-disable-next-line no-unused-vars
        .catch(err => false);
    },
    // eslint-disable-next-line no-empty-pattern
    async deleteZone({}, payload) {
      return fetch(`/v2/zones/${payload.id}`, { 
        credentials: 'same-origin', 
        method: 'DELETE',
        headers: new Headers({ 'Content-Type': 'application/json' })
      })
        .then(res => res.json())
        // eslint-disable-next-line no-unused-vars
        .then(async (data) => payload.id)
        // eslint-disable-next-line no-unused-vars
        .catch(err => false);
    }
  },
  getters: {
    reversedZones: (state) => {
      if (!state.zones.length) return [];

      return {
        type: 'FeatureCollection',
        features: state.zones.map(z => {
          const coordinates = z.coordinates.map(c => c.reverse());
          // eslint-disable-next-line prefer-destructuring
          coordinates[coordinates.length] = coordinates[0];
          return {
            type: 'Feature',
            properties: {
              name: z.name
            },
            id: z.id,
            geometry: {
              type: 'Polygon',
              coordinates: [coordinates]
            }
          }
        })
      }

      // let featureCollection = {
      //   type: 'FeatureCollection',
      //   features: []
      // }
      // state.zones.forEach(z => {
      //   // mapbox uses long,lat so i have to flip the numbers
      //   z.coordinates.map(coord => { return coord = coord.reverse(); });
      //   // hack to close the polygon in mapbox-draw
      //   z.coordinates[z.coordinates.length] = z.coordinates[0];
      //   let feature = {
      //     type: 'Feature',
      //     properties: {
      //       name: z.name
      //     },
      //     id: z.id,
      //     geometry: { type: 'Polygon', coordinates: [z.coordinates] }
      //   };
      //   featureCollection.features.push(feature);
      // })
      // return featureCollection;
    }
  }
}
export default zonesStore;
